'use client'

import { useEffect } from 'react'
import { useLang } from '@/store/useLanguageStore'
import i18next from 'i18next'
import { useRouter } from 'next/navigation'
import { changeLanguageAndPersist, Lang } from '@/utils/localization/language'

export const useI18n = () => {
  const { lang, setLang } = useLang()
  const router = useRouter()

  const changeLanguage = (newLang: Lang) => {
    setLang(newLang)
    changeLanguageAndPersist(newLang)
    router.refresh()
  }

  useEffect(() => {
    if (lang) {
      i18next.changeLanguage(lang)
    }
  }, [lang])

  return { changeLanguage }
}
